import * as React from "react";
import { singleton } from "logic/singleton";
const TableFetchContext = React.createContext(void 0);
export default singleton("contexts.TableFetchContext", () => TableFetchContext);
